import { Injectable } from '@angular/core';

import { RewardTokenType } from 'packages/sports/web/app/src/tokens-base/token-base.models';

import { BetslipType } from '../../../../../core/betslip-type';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class TeaserRewardTypeValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.TeaserReward;

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const currentSelectedType = state.selectedType;

        switch (currentSelectedType) {
            case BetslipType.Single:
            case BetslipType.Combo:
            case BetslipType.System:
            case BetslipType.BetBuilder:
                return true;
            case BetslipType.Teaser:
                return token.rewardTokenType === RewardTokenType.FreeBet;
        }

        return true;
    }
}
